module.exports = __webpack_public_path__ + "img/ruling.33cc695f.png";